<template>
  <form @submit.prevent="submit">
    <base-content>
      <template v-slot:top>
        <hero-header heading="Initial deposit details" />
      </template>

      <div class="row flex-sm-row-reverse justify-content-sm-between">
        <div class="col-sm-6">
          <div class="bg-secondary float-sm-right mb-3 mb-sm-0 p-3">
            Saxon Trust does not hold client money and all funds held in your account are processed and held by Reyker
            Securities plc who are authorised and regulated by the Financial Conduct Authority as custodians and holders
            of client money. Reyker Securities plc are members of the Financial Services Compensation Scheme.
          </div>
        </div>
        <div class="col-sm-6">
          <base-field addon-left="£" label="Please let us know how much you would like to deposit to make your first investment.">
            <base-input numeric placeholder="deposit amount" v-model="deposit" />
          </base-field>
        </div>
      </div>

      <template v-slot:bottom>
        <div class="bg-light py-4">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-sm-6">
                Estimated time to complete: <strong>4 minutes</strong>
              </div>
              <div class="col-sm-6 text-right">
                <base-button icon-right="arrow-right" :loading="saving" primary submit>
                  Continue
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </base-content>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

import HeroHeader from '@/components/HeroHeader.vue'

export default {
  created () {
    this.account = this.$auth.user.accounts.find(account => account._id === this.$route.params.id)
  },

  data: () => ({
    account: {},
    deposit: '',
    saving: false
  }),

  components: {
    HeroHeader
  },

  computed: {
    ...mapGetters({
      schema: 'core/accounts/schema'
    })
  },

  methods: {
    async submit () {
      this.saving = true

      await this.$store.dispatch('core/accounts/update', {
        _id: this.account._id,
        initialDeposit: this.deposit
      })

      this.$router.push({ name: 'account.payment',
        params: {
          id: this.account._id
        } })
    }
  }
}
</script>
